
  <!-- <div class="row">
  <input class="form-control" [placeholder]="placeholderText" (keyup)="onKeypressEvent($event)" [value]="autoSearchDafaultValue" type="text" autocomplete="off">
 </div>
 <input  #autoCompleteInput name="question" id="inputField" [placeholder]="placeholderText" (keyup)="onKeypressEvent($event)" [value]="autoSearchDafaultValue" type="text" autocomplete="off">
    -->
 <div id="autocomplete-wrapper"  >
    <div id="autocomplete-input">
       <input #autoCompleteInput  name="question" id="inputField" [placeholder]="placeholderText" (keyup)="onKeypressEvent($event)" [value]="autoSearchDafaultValue" type="text" autocomplete="off">
   
      </div>
      <!-- <ng-container *ngIf="suggestionEnable">
      <div id="suggestion-list"  [hidden]="!showSearches">
        <div class="search">
          <div *ngFor="let data of searchedList; trackBy: trackById" (click)="setSelected(data)" class="search-result" [innerHTML]="data | searchHighlight :autoSearchDafaultValue">
          </div>
        </div>
        <p class="search" *ngIf="searchedList.length == 0 && autoSearchDafaultValue!=''">No Data found</p>
        
      </div>  
    </ng-container> -->
  </div>  
